import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { SummaryPriceDetailsStyled } from '../SummaryPriceDetailsStyled';
import { rem } from 'polished';

export const SummaryPriceDetailsOV = styled(SummaryPriceDetailsStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    ${({ isBasket, isDealer }) =>
        !isBasket &&
        !isDealer &&
        css`
            border-top: unset;
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-top: ${rem(1)} solid black;
                border-bottom: ${rem(1)} solid black;
            }
        `}

    .totalPriceWrapper {
        @media (max-width: ${breakpoints.md}px) {
            display: flex;

            .totalPrice {
                padding-top: unset !important;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
        }
    }

    .titleWrapper {
        .title {
            text-transform: capitalize;
            font-size: ${rem(22)};
        }
    }

    .descriptionTitle {
        text-transform: uppercase;
        font-size: ${rem(16)};
    }

    .descriptionWrapper {
        .info {
            .key {
                color: ${({ theme }) => theme.colors.grey28};
            }
        }
    }

    .totalPriceWrapper {
        .prefix,
        .suffix {
            text-transform: lowercase;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .totalPrice {
            .cashPrice,
            .monthlyPrice {
                font-size: ${rem(20)};
            }
        }

        .totalPriceTitle {
            font-size: ${rem(16)};

            .offerValidity {
                svg {
                    width: ${rem(24)};
                    height: ${rem(24)};
                    margin-top: ${rem(4)};

                    path {
                        fill: ${({ theme }) => theme.colors.black2};
                    }
                }
            }
        }
    }

    .finance {
        .financePersonalize {
            .financeWidgetLink,
            .financeDetailLinkDesktop {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};

                &:hover,
                &:focus-visible {
                    color: ${({ theme }) => theme.colors.black};
                    border-color: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .configuration {
        button {
            color: ${({ theme }) => theme.colors.black2};

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }

    .infoIcon {
        svg {
            circle {
                fill: ${({ theme }) => theme.colors.black};
                stroke: ${({ theme }) => theme.colors.pureWhite} !important;
            }

            g {
                path {
                    fill: ${({ theme }) => theme.colors.pureWhite};
                }
            }

            > path {
                fill: ${({ theme }) => theme.colors.pureWhite};
            }
        }
    }
`;
